(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6808],{

/***/ 82301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Qg": function() { return /* reexport */ DefaultControls; },
  "ZP": function() { return /* binding */ cms_VideoHero; }
});

// UNUSED EXPORTS: VideoPlayer

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/Grid/index.tsx + 2 modules
var Grid = __webpack_require__(232);
// EXTERNAL MODULE: ./lib/hooks/index.ts + 4 modules
var hooks = __webpack_require__(61499);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./components/global/Button/index.tsx + 2 modules
var Button = __webpack_require__(80772);
;// CONCATENATED MODULE: ./components/cms/VideoHero/constants.ts
var PLAY_ICON = "\u23F5";
var PAUSE_ICON = "\u23F8";
var IS_PLAYING = "isPlaying";
var IS_PAUSED = "isPaused";

// EXTERNAL MODULE: ./components/cms/VideoHero/VideoHero.module.scss
var VideoHero_module = __webpack_require__(99622);
var VideoHero_module_default = /*#__PURE__*/__webpack_require__.n(VideoHero_module);
// EXTERNAL MODULE: ./lib/useSafeContext.ts
var useSafeContext = __webpack_require__(95841);
;// CONCATENATED MODULE: ./components/cms/VideoHero/VideoHeroProvider.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




var ref = _slicedToArray((0,useSafeContext/* default */.Z)(), 2);
var useVideoHero = ref[0], Provider = ref[1];
var VideoHeroProvider = function(param) {
    var children = param.children, video = param.video, autoPlay = param.autoPlay, loop = param.loop, poster = param.poster, videoUrl = param.videoUrl;
    var videoRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(false), muted = ref2[0], setMuted = ref2[1];
    var ref1 = (0,react.useState)(""), videoStatus = ref1[0], setVideoStatus = ref1[1];
    (0,react.useEffect)(function() {
        if (autoPlay) {
            play();
            mute(autoPlay);
        }
    }, [
        autoPlay
    ]);
    var play = function() {
        var ref4, ref3;
        (ref3 = (ref4 = videoRef.current) === null || ref4 === void 0 ? void 0 : ref4.play()) === null || ref3 === void 0 ? void 0 : ref3.then(function() {
            return setVideoStatus(IS_PLAYING);
        });
    };
    var pause = function() {
        var ref5;
        (ref5 = videoRef.current) === null || ref5 === void 0 ? void 0 : ref5.pause();
        setVideoStatus(IS_PAUSED);
    };
    var mute = function(value) {
        setMuted(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider, {
        value: {
            play: play,
            pause: pause,
            mute: mute,
            autoPlay: autoPlay,
            muted: muted,
            loop: loop,
            video: video,
            videoRef: videoRef,
            videoStatus: videoStatus,
            poster: poster,
            videoUrl: videoUrl
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./components/cms/VideoHero/partials/DefaultControls.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







var getButtonStyle = function(param) {
    var color = param.color, activeColor = param.activeColor;
    var style = {};
    if (color) style["--dark-grey"] = color;
    if (activeColor) style["--white"] = activeColor;
    return style;
};
var DefaultControls = function(param) {
    var color = param.color, activeColor = param.activeColor;
    var ref = useVideoHero(), play = ref.play, pause = ref.pause, videoStatus = ref.videoStatus;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: getButtonStyle({
            color: color,
            activeColor: activeColor
        }),
        className: (VideoHero_module_default()).DefaultControls,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (0,clsx_m/* default */.Z)((VideoHero_module_default()).DefaultControls__button, _defineProperty({}, (VideoHero_module_default())["DefaultControls__button--active"], videoStatus === IS_PLAYING)),
                title: "Pause",
                callBack: function() {
                    return play();
                },
                variant: "ghost",
                size: "none",
                children: PLAY_ICON
            }),
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (0,clsx_m/* default */.Z)((VideoHero_module_default()).DefaultControls__button, _defineProperty({}, (VideoHero_module_default())["DefaultControls__button--active"], videoStatus === IS_PAUSED)),
                title: "Pause",
                callBack: function() {
                    return pause();
                },
                variant: "ghost",
                size: "none",
                children: PAUSE_ICON
            })
        ]
    });
};
/* harmony default export */ var partials_DefaultControls = ((/* unused pure expression or super */ null && (DefaultControls)));

;// CONCATENATED MODULE: ./components/cms/VideoHero/partials/VideoPlayer.tsx




var VideoPlayer = function() {
    var ref = useVideoHero(), autoPlay = ref.autoPlay, videoRef = ref.videoRef, play = ref.play, pause = ref.pause, muted = ref.muted, video = ref.video, loop = ref.loop, poster = ref.poster, videoUrl = ref.videoUrl;
    var getSbImage = (0,hooks/* useSbImage */.X8)().getSbImage;
    var getPreloadState = function() {
        if (!autoPlay) return "none";
        return "metadata";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
            ref: videoRef,
            // id={`${file.id}`}
            autoPlay: autoPlay,
            poster: getSbImage(poster === null || poster === void 0 ? void 0 : poster.filename, 1500),
            muted: autoPlay ? autoPlay : muted,
            preload: getPreloadState(),
            loop: loop,
            playsInline: true,
            className: (VideoHero_module_default()).video,
            onTimeUpdate: function() {
                if (videoRef.current.ended) {
                    if (loop) {
                        play();
                    } else {
                        pause();
                    }
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                src: video.filename || videoUrl,
                type: "video/mp4"
            })
        })
    });
};
/* harmony default export */ var partials_VideoPlayer = ((/* unused pure expression or super */ null && (VideoPlayer)));

;// CONCATENATED MODULE: ./components/cms/VideoHero/partials/index.ts



;// CONCATENATED MODULE: ./components/cms/VideoHero/VideoHero.tsx







var VideoHero = function(param) {
    var video = param.video, poster = param.poster, _autoPlay = param.autoPlay, autoPlay = _autoPlay === void 0 ? false : _autoPlay, _loop = param.loop, loop = _loop === void 0 ? false : _loop, footerChildren = param.footerChildren, videoUrl = param.videoUrl;
    var getSbImage = (0,hooks/* useSbImage */.X8)().getSbImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoHeroProvider, {
        video: video,
        autoPlay: autoPlay,
        loop: loop,
        poster: poster,
        videoUrl: videoUrl,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (VideoHero_module_default()).VideoHero,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (VideoHero_module_default()).VideoHero__MobilePosterContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        style: {
                            display: "none"
                        },
                        src: getSbImage(poster === null || poster === void 0 ? void 0 : poster.filename, 800),
                        alt: poster === null || poster === void 0 ? void 0 : poster.alt
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        display: "none"
                    },
                    className: (VideoHero_module_default()).VideoHero__VideoContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                    className: (VideoHero_module_default()).VideoHeroFooter,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                        className: (VideoHero_module_default()).VideoHeroFooter__inner,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        children: footerChildren.map(function(child) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: child
                            }, child.key);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var VideoHero_VideoHero = (VideoHero);

;// CONCATENATED MODULE: ./components/cms/VideoHero/index.ts


/* harmony default export */ var cms_VideoHero = (VideoHero_VideoHero);


/***/ }),

/***/ 16808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var _components_cms_VideoHero__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82301);
/* harmony import */ var _DynamicComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79426);



var VideoWrapper = function(param) {
    var blok1 = param.blok;
    var video = blok1.video, posterImage = blok1.posterImage, autoPlay = blok1.autoPlay, footer = blok1.footer, loop = blok1.loop, videoUrl = blok1.videoUrl;
    var footerChildren = footer.map(function(blok) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DynamicComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            blok: blok
        }, blok._uid);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cms_VideoHero__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        video: video,
        poster: posterImage,
        autoPlay: autoPlay,
        footerChildren: footerChildren,
        loop: loop,
        videoUrl: videoUrl
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VideoWrapper);


/***/ }),

/***/ 99622:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"VideoHero":"VideoHero_VideoHero__6rzqF","VideoHero__VideoContainer":"VideoHero_VideoHero__VideoContainer__Lgyqi","VideoHero__MobilePosterContainer":"VideoHero_VideoHero__MobilePosterContainer__1Ii0q","VideoHeroFooter":"VideoHero_VideoHeroFooter__kxVG9","VideoHeroFooter__inner":"VideoHero_VideoHeroFooter__inner__Bd2Zk","video":"VideoHero_video__uSMSV","DefaultControls":"VideoHero_DefaultControls__P0tUc","DefaultControls__button":"VideoHero_DefaultControls__button__Ud1pE","DefaultControls__button--active":"VideoHero_DefaultControls__button--active__5d1vl"};

/***/ })

}]);